import {connect} from "react-redux";
import {getFilterStats, setFilter, setFilterInstance} from "../../actions/filter";
import FilterPagePriceRange from "../../components/Filter/FilterPagePriceRange";
import {withTranslation} from "react-i18next";
import type {ApplicationState} from "../../reducers";

function mapStateToProps(state: ApplicationState, ownProps) {
	const isPriceRangeInvalid = value => {
		return (value === "Infinity" || value === "-Infinity");
	};
	const productPriceCurrency =
		(state.content
			&& state.content.products
			&& state.content.products[0]
			&& state.content.products[0].price
			&& (state.content.products[0].price.currency
				|| state.content.products[0].price.currencyCode))
		|| null;
	const fallbackCurrency = productPriceCurrency || "EUR";
	const defaultPriceRange = {
		from: 0,
		to: 1000,
		unit: fallbackCurrency
	};
	return {
		filter: state.filter.filter,
		priceBorders: {
			from: isPriceRangeInvalid(state.filter.filterStats.priceRange.from)
				? defaultPriceRange.min
				: Math.floor(state.filter.filterStats.priceRange.from),
			to: isPriceRangeInvalid(state.filter.filterStats.priceRange.to)
				? defaultPriceRange.max
				: Math.ceil(state.filter.filterStats.priceRange.to),
			unit: state.filter.filterStats.priceRange.unit || fallbackCurrency
		}
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		setPriceRange: priceRange => {
			dispatch(setFilter("priceRange", priceRange));
		},
		getPriceFilterStats: filter => {
			dispatch(getFilterStats({...filter, ...{priceRange: null}}));
		},
		setFilterInstance: (instance, subCat) => {
			dispatch(setFilterInstance(instance, subCat));
		},
	};
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(FilterPagePriceRange));
